import { REACT_APP_LOGIN_GATEWAY_API_ENDPOINT } from 'constants/constants'

const urlMapping = {
    login: `${REACT_APP_LOGIN_GATEWAY_API_ENDPOINT}/api/v1/user/agents/login`
}

export default urlMapping
